export function getIndividualCount(
  totalCount,
  { checkedAll, checked, unChecked },
) {
  return checkedAll ? totalCount - unChecked.length : checked.length
}
